import { render, staticRenderFns } from "./PsCalendarGridDayEvent.vue?vue&type=template&id=2950ea2c&scoped=true&"
import script from "./PsCalendarGridDayEvent.vue?vue&type=script&lang=js&"
export * from "./PsCalendarGridDayEvent.vue?vue&type=script&lang=js&"
import style0 from "./PsCalendarGridDayEvent.vue?vue&type=style&index=0&id=2950ea2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950ea2c",
  null
  
)

export default component.exports